import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const Textbox = ({ className, ...rest }) => {
  const _className = className || styles.textbox;
  return (
    <input className={_className} {...rest} />
  );
};

Textbox.propTypes = {
  className: PropTypes.string,
};

Textbox.defaultProps = {
  className: null,
};

export default Textbox;
